import { render, staticRenderFns } from "./ButtonBasic.vue?vue&type=template&id=c90f9194&scoped=true"
import script from "./ButtonBasic.vue?vue&type=script&lang=js"
export * from "./ButtonBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f9194",
  null
  
)

export default component.exports